var URL_REGEX = /(https?:\/\/[^\s]+)/g;
export var parseTextWithUrls = function (text) {
    var parts = [];
    var lastIndex = 0;
    var match;
    // eslint-disable-next-line no-cond-assign
    while ((match = URL_REGEX.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push({ type: 'text', content: text.substring(lastIndex, match.index) });
        }
        parts.push({ type: 'link', content: match[0] });
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) {
        parts.push({ type: 'text', content: text.substring(lastIndex) });
    }
    return parts;
};
